import React from 'react';
import { Box } from '@mui/material';
import { ChatCallingButton } from './ChatCallingButton';
import { VideoCallButton } from './VideoCallButton';

/**
 * Drops the audio + video call buttons into the existing conversation header
 * action row. Styled to sit flush with the surrounding MuiIconButton group.
 */
export const ConverseChatHeaderCalling: React.FC<{
  agentId: string;
  conversationId: string;
  customerInfo: {
    customer_id: string;
    name: string;
    email?: string;
  };
  conversationStatus?: string;
  /**
   * Call buttons are only shown when a human agent is handling the conversation.
   * Pass `true` when AI is disabled (ai_enabled === false) or the conversation
   * has been escalated to a human agent.
   */
  isHumanAgent?: boolean;
}> = ({ agentId, conversationId, customerInfo, isHumanAgent = false }) => {
  if (!isHumanAgent) return null;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      {/* Audio call — matches the IconButton size="small" pattern */}
      <ChatCallingButton
        conversationId={conversationId}
        userId={agentId}
        userType="agent"
        customerInfo={customerInfo}
      />

      {/* Video call */}
      <VideoCallButton
        conversationId={conversationId}
        agentId={agentId}
        customerInfo={customerInfo}
      />
    </Box>
  );
};
